import { BUSINESS_TOOL_SECTIONS } from 'constants/businessTool';

import { IOptionType } from 'interfaces/forms';

import { STATUS_OPTIONS } from 'components/BusinessToolForm/constants/options';

export const prefix = `${BUSINESS_TOOL_SECTIONS.IMPLEMENTATION_PLAN}` as const;

export const STAGES_NAMES = {
  STAGE: 'stage',
  FROM: 'from',
  TO: 'to',
  STATUS: 'status',
} as const;

export interface IStages {
  [STAGES_NAMES.STAGE]: string;
  [STAGES_NAMES.FROM]: string;
  [STAGES_NAMES.TO]: string;
  [STAGES_NAMES.STATUS]: IOptionType;
}

export const stagesInitialValues = {
  [STAGES_NAMES.STAGE]: '',
  [STAGES_NAMES.FROM]: '',
  [STAGES_NAMES.TO]: '',
  [STAGES_NAMES.STATUS]: STATUS_OPTIONS[0],
};

export const IMPLEMENTATION_PLAN_NAMES = {
  STAGES: 'stages',
} as const;

export interface IImplementationPlan {
  [IMPLEMENTATION_PLAN_NAMES.STAGES]: IStages[];
}

export const implementationPlanValues = {
  [IMPLEMENTATION_PLAN_NAMES.STAGES]: [stagesInitialValues],
};
